import { OlciActionTypes } from "../actions";
import { CountryElement } from "../models";

export interface CountriesState {
  countries: CountryElement[];
}

export const countriesInitialState: CountriesState = {
  countries: []
}

export function reducer(state = countriesInitialState, action: any): CountriesState {
  if (action.type === OlciActionTypes.GET_COUNTRIES_SUCCESS) {
    return {...state, ...action.payload}
  }
  return state;
}
